import { render, staticRenderFns } from "./DocumentListViewer.vue?vue&type=template&id=16a3b882&scoped=true&"
import script from "./DocumentListViewer.vue?vue&type=script&lang=ts&"
export * from "./DocumentListViewer.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentListViewer.vue?vue&type=style&index=0&id=16a3b882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a3b882",
  null
  
)

export default component.exports